import { mutate } from "swr";
import {
    setIsLoading,
    setIsPaymentModified,
    setIsSaleModeModified,
    setPayment,
    setSaleMode,
} from "../store";

export async function editSale(
    franchiseID: any,
    updatedRows: any,
    setIsAddSaleSupportClicked: Function,
    setDataIsUpdated: Function,
    dataIsUpdated: boolean | number,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>,
    dataSaleMode?: any,
    dataPayment?: any
) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["saleSupport"],
            data: updatedRows,
        }),
    };
    try {
        const data = await fetchGlobal<any>(apiUrl, requestOptions);

        if (data.error) {
            throw Error("error");
        } else {
            setDataIsUpdated(!dataIsUpdated);
            setIsAddSaleSupportClicked(false);
            if (dataSaleMode !== undefined) {
                setSaleMode(dataSaleMode);
                setIsSaleModeModified();
            }
            if (dataPayment !== undefined) {
                setPayment(dataPayment);
                setIsPaymentModified();
            }
        }
        setIsLoading(false);

        mutate(apiUrl, data);
    } catch (e) {
        setIsLoading(false);
    }
}
